import React from "react";
import ComingSoonPage from "../coming-soon/coming-soon";

function UserProfile() {
  return <ComingSoonPage />;
}

export default UserProfile;
